import SvgBrand from './SvgBrand';

export default SvgBrand;
